﻿namespace Utilities

module HtmlHelpers =

    open Fable.React
    open Fable.React.Props


    let onEnter f =
        OnKeyDown (fun e ->
            if e.key = "Enter" then
                f e
        )


    let onSelect msg =
        OnChange (fun e -> msg e.Value)


    let onSelectInt f =
        OnChange (fun e ->
            match System.Int32.TryParse e.Value with
            | true, i -> f i
            | _ -> ()
        )


    let onSelectMaybe msg =
        OnChange (fun e ->
            if System.String.IsNullOrWhiteSpace(e.Value) then
                msg None
            else
                msg (Some e.Value)
        )

    let onSelectMaybeBool msg =
        OnChange (fun e ->
            match e.Value with
            | "" -> msg None
            | "true" -> msg (Some true)
            | "false" -> msg (Some false)
            | _ -> ()
        )
